import { getFlatTourBookingSchedule } from './getFlatTourBookingSchedule';
import { IAppState } from '../../common/state';

export function getIsFlatTourBookingAvailable(state: IAppState) {
  return Boolean(getFlatTourBookingSchedule(state));
}
